import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { JpClassAttendanceStaff } from "./JpClassAttendanceStaff";
import type { JpClassSessionDTOBase } from "./JpClassSessionDTOBase";
import type { JpClassStaff } from "./JpClassStaff";
import type { TrackedBase } from "./TrackedBase";

export class JpClassSessionStaff implements JpClassSessionDTOBase, TrackedBase {
  constructor(public readonly sessionId: number, public readonly sessionDatetime: Date, public readonly lengthOverride: number | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly instanceId: JpClassStaff | null, public readonly attendance: Array<JpClassAttendanceStaff> | null) {
    this.cbiServiceContext = null;
    this.instanceIdLoaded = this.instanceId != null;
    this.instanceIdCached = this.instanceId;
    this.attendanceLoaded = this.attendance != null;
    this.attendanceCached = this.attendance;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private instanceIdLoaded: boolean;
  private instanceIdCached: JpClassStaff | null;
  private attendanceLoaded: boolean;
  private attendanceCached: Array<JpClassAttendanceStaff> | null;
  async instanceIdLazy(): Promise<JpClassStaff> {
    if (!this.instanceIdLoaded) {
      this.instanceIdCached = await this.cbiServiceContext!.jpClassService().getJpClassSessionStaffInstanceId(this.sessionId);
      this.instanceIdLoaded = true;
    }
    return this.instanceIdCached!;
  }
  async attendanceLazy(): Promise<Array<JpClassAttendanceStaff>> {
    if (!this.attendanceLoaded) {
      this.attendanceCached = await this.cbiServiceContext!.jpClassService().getJpClassSessionStaffAttendance(this.sessionId);
      this.attendanceLoaded = true;
    }
    return this.attendanceCached!;
  }
}
